import { useFlags } from "launchdarkly-react-client-sdk";

import { useConfigContext } from "shared/contexts/ConfigContext";

import { routes } from "services/routes";
import { RouteDataProps } from "services/routesConfig";

export const useRouteDataProps = (): RouteDataProps => {
  const { general, pages, userInfo } = useConfigContext();
  const flags = useFlags();

  return {
    flags,
    pages,
    general: {
      ...general,
      rootPage: general.rootPage ? general.rootPage : routes.vehicles,
    },
    userInfo,
  };
};
